import { Checkbox } from '../Common/Checkbox';
import { useTranslate } from '@/hooks/useTranslate';

interface SaveCardCheckboxProps {
  isSaveCard: boolean;
  setIsSaveCard: (value: boolean) => void;
  // i18n key for the label. Defaults to the card copy; PayPal vault opt-in
  // passes its own ("Save my details for next time").
  labelKey?: string;
}

export const SaveCardCheckbox = ({
  isSaveCard,
  setIsSaveCard,
  labelKey = 'saveCardCheckbox',
}: SaveCardCheckboxProps) => {
  const { t } = useTranslate();

  const handleClick = () => {
    setIsSaveCard(!isSaveCard);
  };

  return (
    <div
      data-testid="save-card-checkbox-wrapper"
      className="flex items-center w-full gap-2 cursor-pointer"
      onClick={handleClick}
    >
      <Checkbox data-testid="save-card-checkbox" checked={isSaveCard} />
      <div data-testid="save-card-label" className="text-sm text-primary font-medium">
        {t(labelKey)}
      </div>
    </div>
  );
};
